import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';

// components
import { AppComponent } from './app.component';
import { DelegationComponent } from './delegation/delegation.component';

//Services
import { EnvironmentService } from './utility/environment.service';
import { AuthenticationService } from './core/services/authentication.service';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { initializeKeycloak } from './utility/app.init';
import { MenubarComponent } from './menubar/menubar.component';
import { LogoutComponent } from './logout/logout.component';
import { NavbarComponent } from './navbar/navbar.component';
import { DialogModule } from 'primeng/dialog';
import { DialogService } from 'primeng/dynamicdialog';

import { MaterialModule } from './material/material.module';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { PrimengModule } from './primeng/primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FooterComponent } from './footer/footer.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CustomDatePipe } from './utility/custom.datepipe';
import { DatePipe } from '@angular/common';
import {
  CommonModule,
  HashLocationStrategy,
  LocationStrategy,
  PathLocationStrategy,
} from '@angular/common';
import { ErrorHandlerComponent } from './error-handler/error-handler/error-handler.component';
import { AdministrationComponent } from './administration/administration.component';
import { PopoverBtnComponent } from './components/popover-btn/popover-btn.component';
import { EditInrefComponent } from './administration/edit-inref/edit-inref.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { EditDelegationComponent } from './delegation/edit-delegation/edit-delegation.component';
import { DelegationHistoryComponent } from './delegation/delegation-history/delegation-history.component';
import { EditDelegFormComponent } from './delegation/edit-deleg-form/edit-deleg-form.component';
import { RouterComponent } from './router/router.component';
import { EditRouteComponent } from './router/edit-route/edit-route.component';
import { EditRouteFormComponent } from './router/edit-route-form/edit-route-form.component';
import { RouteSenderDataComponent } from './router/route-sender-data/route-sender-data.component';
import { RouteHistoryComponent } from './router/route-history/route-history.component';
import { CanDeactivateGuard } from './utility/can-exit.guard';
import { ReportsComponent } from './reports/reports.component';
import { ConsentDialogComponent } from './consent-dialog/consent-dialog.component';
import { TermsDialogComponent } from './consent-dialog/terms-dialog/terms-dialog.component';
import { SessionStorageService } from './administration/services/session-storage.service';
import { ProcessingDialogComponent } from './shared/processing-dialog/processing-dialog.component';
@NgModule({
  declarations: [
    AppComponent,
    DelegationComponent,
    MenubarComponent,
    LogoutComponent,
    PopoverBtnComponent,
    NavbarComponent,
    FooterComponent,
    CustomDatePipe,
    ErrorHandlerComponent,
    AdministrationComponent,
    EditInrefComponent,
    EditDelegationComponent,
    DelegationHistoryComponent,
    EditDelegFormComponent,
    RouterComponent,
    EditRouteComponent,
    EditRouteFormComponent,
    RouteSenderDataComponent,
    RouteHistoryComponent,
    ReportsComponent,
    ConsentDialogComponent,
    TermsDialogComponent,
    ProcessingDialogComponent,
  ],
  imports: [
    //keycloak
    KeycloakAngularModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CommonModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    RadioButtonModule,
    ReactiveFormsModule,
    RadioButtonModule,
    DialogModule,
    //angular material
    MaterialModule,
    PrimengModule,
    NgbModule,
    FontAwesomeModule,
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    // RuleService,
    EnvironmentService,
    ConfirmationService,
    CanDeactivateGuard,
    MessageService,
    DialogService,
    DatePipe,
    // RegistrationService,
    AuthenticationService,
    SessionStorageService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService, EnvironmentService, AuthenticationService],
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
